// SCHIEBLER — dati prodotto (solo IT). Fonte: dati forniti dal cliente.
// NB: i valori hex dei campioni colore sono INDICATIVI in attesa delle foto ufficiali
// (i NOMI dei colori sono la fonte di verità). Nessun colore/esecuzione/foto inventato:
// dove i nomi non sono confermati, `colors: []` + nota, `executions: []` + nota.

export const SCHIEBLER_CATEGORIES = [
  { id: "calze-indumenti", label: "Calze e indumenti compressivi" },
  { id: "sistemi-adattivi", label: "Sistemi compressivi adattivi" },
  { id: "ortesi-tutori", label: "Ortesi e tutori" },
  { id: "accessori", label: "Accessori" },
];

const HEALTH_NOTE =
  "Le informazioni riportate hanno carattere generale e non sostituiscono la valutazione del medico o del professionista sanitario. La scelta del prodotto, della configurazione e della classe di compressione deve essere effettuata sulla base delle indicazioni ricevute e delle caratteristiche individuali.";

// FAQ generali sulle calze a compressione graduata (condivise dalle calze terapeutiche).
export const CALZE_FAQ = [
  ["Quando vanno indossate le calze compressive?", "In genere si calzano al mattino appena svegli, con la gamba a riposo e prima che si formi il gonfiore, e si rimuovono la sera, salvo diversa indicazione del medico."],
  ["Come si indossano correttamente?", "Si rivolta la calza fino al tallone, si inserisce il piede e si srotola lentamente il tessuto sulla gamba, evitando pieghe o arrotolamenti. L'uso di appositi guanti facilita la presa e protegge il tessuto da unghie e anelli."],
  ["Cosa indica la classe di compressione?", "La compressione si misura in mmHg, non in denari (che indicano solo lo spessore del filato). Secondo lo standard tedesco RAL le classi vanno indicativamente dalla 1 alla 4, con pressione crescente alla caviglia. La classe adatta è indicata dal medico."],
  ["Come si lavano e ogni quanto si sostituiscono?", "Preferibilmente a mano in acqua tiepida (max 40°C) con sapone neutro, senza strizzare né usare candeggina o ammorbidente, asciugando in orizzontale lontano da fonti di calore. Con l'uso quotidiano perdono elasticità e vanno generalmente sostituite dopo alcuni mesi; buchi o smagliature ne compromettono l'efficacia."],
  ["Come scelgo la taglia giusta?", "La taglia si basa sulle misure della gamba, non sul numero di scarpa. Per questo MEDISISTEM effettua una misurazione professionale: la calza giusta non si sceglie, si misura."],
];

// Libreria generale delle esecuzioni (icone interne). Finché non arriva la tabella
// definitiva NON rappresenta la reale disponibilità per prodotto (nota "provvisorio").
export const EXECUTIONS_LIBRARY = [
  { id: "gambaletto", label: "Gambaletto" },
  { id: "coscia", label: "Calza alla coscia" },
  { id: "autoreggente", label: "Autoreggente" },
  { id: "monocollant", label: "Monocollant" },
  { id: "collant", label: "Collant" },
  { id: "bracciale", label: "Bracciale" },
  { id: "guanto", label: "Guanto" },
];

// ---------------- Guida misure (schema gamba + tabella circonferenze) ----------------
// Ordine dei punti di misurazione dal basso (caviglia/piede) verso l'alto (coscia).
export const POINT_ORDER = ["cA", "cY", "cB", "cB1", "cC", "cD", "cE", "cF", "cG"];

// Punti di misurazione. Descrizione fornita SOLO per i punti confermati dal cliente
// (cB, cC, cD, cG). Gli altri punti restano senza interpretazioni aggiuntive.
export const MEASURE_POINTS = [
  { id: "cA" },
  { id: "cY" },
  { id: "cB", key: true, desc: "Circonferenza della caviglia" },
  { id: "cB1" },
  { id: "cC", key: true, desc: "Circonferenza del polpaccio" },
  { id: "cD", key: true, desc: "Circonferenza sotto il ginocchio" },
  { id: "cE" },
  { id: "cF" },
  { id: "cG", key: true, desc: "Circonferenza nella parte alta della coscia" },
];

// Colonne taglie (le varianti "Plus" non indicano una classe di compressione superiore).
export const SIZE_COLUMNS = [
  "1", "1 Plus", "2", "2 Plus", "3", "3 Plus", "4", "4 Plus", "5", "5 Plus", "6", "6 Plus", "7", "7 Plus",
];

// Tabella circonferenze in centimetri — trascritta ESATTAMENTE dall'allegato ufficiale
// (verificata manualmente cella per cella). Valori in ordine delle colonne SIZE_COLUMNS.
export const CIRCUMFERENCE_TABLE = {
  cA: ["17-21", "17-21", "19-23", "19-23", "21-25", "21-25", "23-27", "23-27", "25-29", "25-29", "27-31", "27-31", "29-33", "29-33"],
  cY: ["26-31", "26-31", "28-33", "28-33", "29-34", "29-34", "31-36", "31-36", "32-37", "32-37", "34-39", "34-39", "36-41", "36-41"],
  cB: ["18-20", "18-20", "20-22", "20-22", "22-24", "22-24", "24-26", "24-26", "26-28", "26-28", "28-30", "28-30", "30-32", "30-32"],
  cB1: ["24-26", "24-26", "26-28", "26-28", "28-30", "28-30", "30-33", "30-33", "32-35", "32-35", "34-37", "34-37", "36-39", "36-39"],
  cC: ["29-33", "29-35", "31-35", "31-37", "33-37", "33-39", "35-39", "35-42", "37-42", "37-45", "39-45", "39-47", "41-48", "41-52"],
  cD: ["28-30", "28-34", "30-34", "30-36", "32-36", "32-38", "34-38", "34-41", "36-41", "36-43", "38-43", "38-45", "40-45", "40-49"],
  cE: ["30-34", "30-37", "33-37", "33-39", "35-39", "35-41", "38-41", "38-44", "40-44", "40-46", "42-46", "42-48", "44-48", "44-52"],
  cF: ["39-43", "39-49", "41-46", "41-52", "44-49", "44-55", "47-52", "47-58", "50-55", "50-61", "53-58", "53-64", "56-61", "56-67"],
  cG: ["43-48", "43-55", "45-51", "45-59", "49-55", "49-63", "53-59", "53-66", "57-63", "57-69", "61-66", "61-72", "64-69", "64-75"],
};

// Metadati esecuzioni: fino a quale punto arriva l'indumento e quale gamba copre.
// upTo = punto di misurazione più alto interessato dall'esecuzione.
export const EXECUTION_META = {
  gambaletto: { label: "Gambaletto", icon: "gambaletto", upTo: "cD", leg: "single" },
  autoreggente: { label: "Calza autoreggente", icon: "autoreggente", upTo: "cG", leg: "single" },
  "monocollant-dx": { label: "Monocollant destro", icon: "monocollant", upTo: "cG", leg: "right" },
  "monocollant-sx": { label: "Monocollant sinistro", icon: "monocollant", upTo: "cG", leg: "left", mirror: true },
  collant: { label: "Collant", icon: "collant", upTo: "cG", leg: "both" },
};

// Punti visibili per una esecuzione (da cA fino al punto "upTo" incluso).
export const visiblePoints = (upTo) => {
  const i = POINT_ORDER.indexOf(upTo);
  return i < 0 ? POINT_ORDER : POINT_ORDER.slice(0, i + 1);
};

// Esecuzioni di un prodotto risolte con i metadati.
export const resolveExecutions = (ids = []) =>
  ids.map((id) => ({ id, ...EXECUTION_META[id] })).filter((e) => e.label);

// Palette colori condivisa per le calze a maglia piatta (GOLDPUNKT KARAT, DOKTUS).
export const SEVEN_COLORS = [
  { id: "albicocca", name: "Albicocca", hex: "#F2B79B" },
  { id: "caramello", name: "Caramello", hex: "#B5793E" },
  { id: "nero", name: "Nero", hex: "#1A1A1A" },
  { id: "blu-notte", name: "Blu notte", hex: "#1B2A4A" },
  { id: "verde-foresta", name: "Verde foresta", hex: "#244634" },
  { id: "bordeaux", name: "Rosso bordeaux", hex: "#5E1F2A" },
  { id: "blu-reale", name: "Blu reale", hex: "#1E4FA3" },
];

export const SCHIEBLER_PRODUCTS = [
  // ---------------- CALZE E INDUMENTI COMPRESSIVI ----------------
  {
    slug: "star-cotton",
    faq: CALZE_FAQ,
    id: "sch-star",
    name: "STAR COTTON",
    macro: "calze-indumenti",
    featured: true,
    ralCertified: true,
    category: "Calze compressive per disturbi venosi",
    title: "La calza compressiva in morbida fibra naturale",
    features: [
      "Lavorazione a maglia circolare con fibre di cotone",
      "Particolarmente delicata sulla pelle e resistente",
      "Disponibile nelle classi di compressione 1 e 2",
    ],
    description:
      "Calza compressiva progettata per offrire comfort anche a chi predilige fibre naturali delicate sulla pelle. I filati di cotone di alta qualità, appositamente trattati, avvolgono la pelle con morbidezza. La confortevole lavorazione a maglia la rende discreta e resistente anche durante un utilizzo fisicamente intenso. STAR COTTON è pensata per il trattamento dei disturbi venosi cronici, combinando la compressione con filati di origine naturale.",
    materialNote: "Il contatto con la pelle avviene esclusivamente attraverso la componente in cotone.",
    classes: [
      {
        id: "cc1",
        label: "Classe 1",
        material: [["Cotone", "29%"], ["Elastan", "29%"], ["Poliammide", "42%"]],
        indications: ["Compressione moderata", "Vene varicose moderate", "Vene varicose in gravidanza", "Capillari dilatati"],
      },
      {
        id: "cc2",
        label: "Classe 2",
        material: [["Cotone", "42%"], ["Elastan", "32%"], ["Poliammide", "26%"]],
        indications: [
          "Compressione moderata",
          "Vene varicose gravi",
          "Moderata tendenza all'edema dopo trombosi venosa",
          "Insufficienza valvolare delle vene profonde",
          "Condizioni successive a traumi delle gambe, come fratture, lacerazioni muscolari o sclerosi, secondo indicazione sanitaria",
        ],
      },
    ],
    variants: ["Con tallone e punta aperta", "Disponibile in diverse lunghezze, dalla corta alla XL"],
    colors: [
      { id: "petrolio", name: "Petrolio", hex: "#1C6E68" },
      { id: "sabbia", name: "Sabbia", hex: "#D7BC94" },
      { id: "nero", name: "Nero", hex: "#1A1A1A" },
    ],
    cover: "/products/star-cotton/star-cotton-petrolio-1.webp",
    photos: [
      { src: "/products/star-cotton/star-cotton-petrolio-1.webp", color: "petrolio", execution: "autoreggente" },
      { src: "/products/star-cotton/star-cotton-nero-1.webp", color: "nero", execution: "autoreggente" },
      { src: "/products/star-cotton/star-cotton-sabbia-1.webp", color: "sabbia" },
      { src: "/products/star-cotton/star-cotton-sabbia-2.webp", color: "sabbia" },
      { src: "/products/star-cotton/star-cotton-sabbia-3.webp", color: "sabbia" },
    ],
    availableExecutions: ["gambaletto", "autoreggente", "monocollant-dx", "monocollant-sx", "collant"],
    sizeGuide: "standard",
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "goldpunkt-karat",
    faq: CALZE_FAQ,
    id: "sch-gold",
    name: "GOLDPUNKT KARAT",
    macro: "calze-indumenti",
    featured: true,
    ralCertified: true,
    category: "Calze compressive per edema",
    title: "La calza compressiva a maglia piatta ad elevata stabilità pressoria",
    features: [
      "Elevata stabilità della pressione, personalizzata in base alle esigenze individuali",
      "Struttura contenitiva e modellante",
      "Disponibile nelle classi di compressione da 2 a 4",
    ],
    description:
      "Calza compressiva a maglia piatta, disponibile nelle classi di compressione 2, 3 e 4 e realizzata su misura per gambe e braccia che necessitano di un supporto affidabile. La struttura robusta e la piacevole elasticità favoriscono il comfort durante l'intera giornata. Offre un'elevata stabilità della compressione nelle zone in cui è necessaria.",
    classes: [
      {
        id: "cc2",
        label: "Classe 2 (GP75)",
        material: [["Poliammide", "66%"], ["Elastan", "34%"]],
        indications: [
          "Danni o alterazioni della funzione e della struttura vascolare venosa o linfatica della parte inferiore della gamba, del ginocchio o della coscia, per esempio: vene varicose in gravidanza associate a edema; condizioni successive a stripping, scleroterapia o chirurgia venosa; condizioni successive a tromboflebite; condizioni successive alla guarigione di ulcere venose; trombosi acuta.",
          "Può essere indicata, sulla base della valutazione sanitaria, in presenza di gonfiore o edema moderato, per la riduzione dell'edema, il sollievo dal fastidio e dal dolore e la profilassi delle recidive dopo ulcere venose.",
        ],
      },
      {
        id: "cc3",
        label: "Classe 3 (GP75)",
        material: [["Poliammide", "62%"], ["Elastan", "38%"]],
        indications: [
          "Trombosi acuta",
          "Insufficienza post-trombotica",
          "Linfedema di stadio II",
          "Ulcera venosa della gamba",
          "Gonfiore significativo",
          "Edema ed eventuali alterazioni cutanee",
          "Può essere indicata, sulla base della valutazione sanitaria, per la riduzione dell'edema, il sollievo dal fastidio e dal dolore e il trattamento delle ulcere venose.",
        ],
      },
      {
        id: "cc4",
        label: "Classe 4 (GP75)",
        material: [["Poliammide", "58%"], ["Elastan", "42%"]],
        indications: [
          "Linfedema di stadio III",
          "Elefantiasi",
          "Gonfiore ed edema marcati",
          "Alterazioni cutanee significative",
          "Può essere indicata, sulla base della valutazione sanitaria, per la riduzione dell'edema e il sollievo dal fastidio e dal dolore.",
        ],
      },
    ],
    variants: [
      "Disponibile in differenti lunghezze per gamba",
      "Utilizzabile anche nella zona del braccio",
      "Realizzata su misura",
    ],
    cover: "/products/goldpunkt-karat/goldpunkt-karat-albicocca-1.webp",
    photos: [
      { src: "/products/goldpunkt-karat/goldpunkt-karat-albicocca-1.webp", color: "albicocca" },
      { src: "/products/goldpunkt-karat/goldpunkt-karat-albicocca-2.webp", color: "albicocca" },
      { src: "/products/goldpunkt-karat/goldpunkt-karat-albicocca-3.webp", color: "albicocca" },
      { src: "/products/goldpunkt-karat/goldpunkt-karat-albicocca-4.webp", color: "albicocca" },
      { src: "/products/goldpunkt-karat/goldpunkt-karat-caramello-1.webp", color: "caramello" },
      { src: "/products/goldpunkt-karat/goldpunkt-karat-caramello-2.webp", color: "caramello" },
      { src: "/products/goldpunkt-karat/goldpunkt-karat-caramello-3.webp", color: "caramello" },
      { src: "/products/goldpunkt-karat/goldpunkt-karat-caramello-4.webp", color: "caramello" },
    ],
    colors: SEVEN_COLORS,
    availableExecutions: ["gambaletto", "autoreggente", "collant"],
    madeToMeasure: true,
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "doktus",
    faq: CALZE_FAQ,
    id: "sch-doktus",
    name: "DOKTUS",
    macro: "calze-indumenti",
    featured: true,
    ralCertified: true,
    category: "Calze compressive per edema",
    title: "La calza compressiva morbida ed elastica a maglia piatta",
    features: [
      "Realizzata su misura per gambe che richiedono particolare attenzione",
      "Elevato comfort durante l'utilizzo",
      "Disponibile nella classe di compressione 2",
    ],
    description:
      "Indumento compressivo a maglia piatta caratterizzato da un materiale particolarmente morbido ed elastico, progettato per adattarsi comodamente a gambe e braccia e accompagnare i movimenti durante l'utilizzo quotidiano. DOKTUS unisce discrezione, comfort ed efficacia terapeutica ed è disponibile nella classe di compressione 2.",
    classes: [
      {
        id: "cc2",
        label: "Classe 2 (DN1, maglia piatta)",
        material: [["Poliammide", "58%"], ["Elastan", "42%"]],
        indications: [
          "Vene varicose in gravidanza associate a edema",
          "Condizioni successive a stripping, scleroterapia o chirurgia venosa",
          "Condizioni successive a tromboflebite",
          "Condizioni successive alla guarigione di ulcere venose",
          "Trombosi acuta",
          "Gonfiore o edema moderato",
          "Può essere indicata, sulla base della valutazione sanitaria, per la riduzione dell'edema, il sollievo dal fastidio e dal dolore e la profilassi delle recidive dopo ulcere venose.",
        ],
      },
    ],
    variants: ["Utilizzabile anche sulle braccia", "Realizzata su misura"],
    cover: "/products/doktus/doktus-blu-notte-1.webp",
    photos: [
      { src: "/products/doktus/doktus-blu-notte-1.webp", color: "blu-notte" },
    ],
    colors: SEVEN_COLORS,
    availableExecutions: ["gambaletto", "autoreggente", "collant"],
    madeToMeasure: true,
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "venesso",
    faq: CALZE_FAQ,
    id: "sch-venesso",
    name: "VENESSO",
    macro: "calze-indumenti",
    featured: false,
    ralCertified: true,
    category: "Calze e indumenti compressivi",
    title: "La calza compressiva classica e affidabile",
    features: [
      "Lavorazione a maglia circolare, morbida e disponibile in numerosi colori",
      "Facile da indossare e rimuovere",
      "Disponibile nelle classi di compressione 1 e 2",
    ],
    description:
      "VENESSO è una calza compressiva versatile per l'utilizzo quotidiano, indicata nel trattamento delle patologie venose croniche. La maglia resistente e morbida accompagna la forma della gamba e favorisce il comfort durante la giornata.",
    classes: [
      {
        id: "cc1",
        label: "Classe 1",
        material: [["Poliammide", "59%"], ["Elastan", "41%"]],
        indications: ["Compressione moderata", "Varicosi moderata", "Vene varicose in gravidanza", "Teleangectasie"],
      },
      {
        id: "cc2",
        label: "Classe 2",
        material: [["Poliammide", "56%"], ["Elastan", "44%"]],
        indications: [
          "Compressione media",
          "Varicosi grave",
          "Moderata tendenza all'edema dopo trombosi venosa",
          "Insufficienza valvolare delle vene profonde",
          "Condizioni successive a traumi delle gambe, secondo indicazione sanitaria",
        ],
      },
    ],
    variants: [
      "Disponibile senza punta su richiesta",
      "Disponibile di serie e su misura",
      "Versione Plus disponibile nelle diverse configurazioni",
    ],
    cover: "/products/venesso/venesso-blu-reale-1.webp",
    photos: [
      { src: "/products/venesso/venesso-blu-reale-1.webp", color: "blu-reale" },
    ],
    colors: [
      { id: "caramello", name: "Caramello", hex: "#B5793E" },
      { id: "nero", name: "Nero", hex: "#1A1A1A" },
      { id: "blu-reale", name: "Blu reale", hex: "#1E4FA3" },
    ],
    availableExecutions: ["gambaletto", "autoreggente", "collant"],
    sizeGuide: "standard",
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "handteile",
    faq: CALZE_FAQ,
    id: "sch-handteile",
    name: "HANDTEILE",
    macro: "calze-indumenti",
    featured: false,
    ralCertified: false,
    category: "Calze e indumenti compressivi",
    title: "Il guanto compressivo realizzato su misura",
    cover: "/products/handteile/handteile-1.jpg",
    photos: [
      { src: "/products/handteile/handteile-1.jpg" },
      { src: "/products/handteile/handteile-2.jpg" },
    ],
    features: [
      "Elevata stabilità contenitiva",
      "Numerose configurazioni personalizzabili",
      "Disponibile nelle classi di compressione da 1 a 3",
    ],
    description:
      "I guanti compressivi SCHIEBLER uniscono compressione efficace e comfort durante l'utilizzo. Sono disponibili esclusivamente come prodotti realizzati su misura, per adattarsi alla complessa struttura anatomica e funzionale della mano e alle esigenze individuali.",
    material: [["Materiale", "Disponibile nelle diverse qualità dei prodotti compressivi SCHIEBLER. La composizione varia in base alla linea e alla configurazione prescritta."]],
    variants: [
      "Oltre dieci configurazioni e dettagli speciali",
      "Produzione esclusivamente su misura",
    ],
    indications: [
      "Edema post-operatorio e post-traumatico",
      "Linfedema e lipedema negli stadi 1 e 2",
      "Stati congestizi associati a paresi o paresi parziale degli arti",
    ],
    colors: [],
    colorsNote: "Colore standard.",
    availableExecutions: [],
    madeToMeasure: true,
    device: true,
    healthNote: HEALTH_NOTE,
  },

  // ---------------- SISTEMI COMPRESSIVI ADATTIVI ----------------
  {
    slug: "easywrap-strong-knee",
    id: "sch-easywrap-knee",
    name: "EASYWRAP STRONG KNEE",
    macro: "sistemi-adattivi",
    featured: false,
    ralCertified: false,
    category: "Sistemi compressivi adattivi",
    title: "L'alternativa efficace al bendaggio del ginocchio",
    cover: "/products/easywrap-strong-knee/easywrap-strong-knee-sabbia-1.webp",
    photos: [
      { src: "/products/easywrap-strong-knee/easywrap-strong-knee-sabbia-1.webp", color: "sabbia" },
      { src: "/products/easywrap-strong-knee/easywrap-strong-knee-sabbia-2.webp", color: "sabbia" },
      { src: "/products/easywrap-strong-knee/easywrap-strong-knee-sabbia-3.webp", color: "sabbia" },
      { src: "/products/easywrap-strong-knee/easywrap-strong-knee-sabbia-4.webp", color: "sabbia" },
    ],
    features: [
      "Indicato per il trattamento dell'edema durante la fase di decongestione",
      "Facile da indossare, rimuovere e regolare",
      "Compressione da 30 a 40 mmHg",
    ],
    description:
      "Sistema compressivo medicale adattabile utilizzabile, secondo indicazione sanitaria e dopo adeguate istruzioni, come alternativa al bendaggio elastico tradizionale durante la fase di decongestione. Dopo la riduzione dell'edema, il percorso compressivo può proseguire con calze medicali a maglia circolare o piatta, in base all'indicazione ricevuta.",
    pressure: "30–40 mmHg",
    material: [["Poliammide", "83%"], ["Elastan", "17%"]],
    sizes: ["XS", "S", "M", "L", "XL"],
    indications: [
      "Uso temporaneo nella fase iniziale di decongestione del linfedema, dell'edema venoso pronunciato e delle ulcere venose degli arti inferiori, in alternativa al bendaggio, quando l'utilizzatore è in grado di indossare, rimuovere e regolare autonomamente il sistema dopo aver ricevuto le opportune istruzioni.",
    ],
    colors: [
      { id: "sabbia", name: "Sabbia", hex: "#D9C7A8" },
      { id: "nero", name: "Nero", hex: "#1A1A1A" },
    ],
    availableExecutions: [],
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "easywrap-strong-foot",
    id: "sch-easywrap-foot",
    name: "EASYWRAP STRONG FOOT",
    macro: "sistemi-adattivi",
    featured: false,
    ralCertified: false,
    category: "Sistemi compressivi adattivi",
    title: "L'alternativa efficace al bendaggio del piede",
    cover: "/products/easywrap-strong-foot/easywrap-strong-foot-sabbia-1.webp",
    photos: [
      { src: "/products/easywrap-strong-foot/easywrap-strong-foot-sabbia-1.webp", color: "sabbia" },
      { src: "/products/easywrap-strong-foot/easywrap-strong-foot-sabbia-2.webp", color: "sabbia" },
      { src: "/products/easywrap-strong-foot/easywrap-strong-foot-sabbia-3.webp", color: "sabbia" },
    ],
    features: [
      "Indicato per il trattamento dell'edema durante la fase di decongestione",
      "Facile da indossare, rimuovere e regolare",
      "Compressione da 30 a 40 mmHg",
    ],
    description:
      "Sistema compressivo medicale adattabile utilizzabile, secondo indicazione sanitaria e dopo adeguate istruzioni, come alternativa al bendaggio elastico tradizionale durante la fase di decongestione. Dopo la riduzione dell'edema, il percorso compressivo può proseguire con calze medicali a maglia circolare o piatta, in base all'indicazione ricevuta.",
    pressure: "30–40 mmHg",
    material: [["Poliammide", "83%"], ["Elastan", "17%"]],
    sizes: ["XS", "S", "M", "L", "XL"],
    footLength: ["Regular", "Long"],
    indications: [
      "Uso temporaneo nella fase iniziale di decongestione del linfedema, dell'edema venoso pronunciato e delle ulcere venose degli arti inferiori, in alternativa al bendaggio, quando l'utilizzatore è in grado di indossare, rimuovere e regolare autonomamente il sistema dopo aver ricevuto le opportune istruzioni.",
    ],
    colors: [
      { id: "sabbia", name: "Sabbia", hex: "#D9C7A8" },
      { id: "nero", name: "Nero", hex: "#1A1A1A" },
    ],
    availableExecutions: [],
    device: true,
    healthNote: HEALTH_NOTE,
  },

  // ---------------- ORTESI E TUTORI ----------------
  {
    slug: "air-soft-splint",
    id: "sch-air-soft-splint",
    name: "AIR-SOFT SPLINT",
    macro: "ortesi-tutori",
    featured: false,
    ralCertified: false,
    category: "Ortesi e tutori",
    title: "Il robusto tutore a doppio guscio per la caviglia",
    cover: "/products/ortesi-tutori/air-soft-splint-1.webp",
    photos: [
      { src: "/products/ortesi-tutori/air-soft-splint-1.webp" },
      { src: "/products/ortesi-tutori/air-soft-splint-2.webp" },
      { src: "/products/ortesi-tutori/air-soft-splint-3.webp" },
      { src: "/products/ortesi-tutori/air-soft-splint-4.webp" },
    ],
    features: [
      "Stabilizza la caviglia e limita i movimenti di rotazione interna ed esterna",
      "Si applica rapidamente grazie alla morbida imbottitura",
      "Può essere indossato anche all'interno della scarpa",
    ],
    description:
      "Grazie agli inserti laterali anatomici, AIR-SOFT SPLINT stabilizza efficacemente la caviglia e aiuta a prevenire le torsioni laterali. La barra di supporto regolabile sul tallone e le ampie cinghie consentono di adattare il tutore alle esigenze individuali. L'imbottitura interna in memory foam si conforma alla caviglia e favorisce il comfort durante l'utilizzo quotidiano.",
    material: [["Nylon", "45%"], ["Polipropilene", "30%"], ["Schiuma di poliuretano", "20%"], ["Neoprene", "5%"]],
    side: ["Destro", "Sinistro"],
    indications: [
      "Danni dell'articolazione della caviglia e dell'apparato legamentoso, come contusioni, distorsioni e lesioni capsulari",
      "Stabilizzazione post-operatoria dopo sutura dei legamenti",
    ],
    colors: [],
    availableExecutions: [],
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "para-epicondylitis",
    id: "sch-para-epicondylitis",
    name: "PARA EPICONDYLITIS",
    macro: "ortesi-tutori",
    featured: false,
    ralCertified: false,
    category: "Ortesi e tutori",
    title: "La classica fascia compressiva per il gomito",
    cover: "/products/ortesi-tutori/para-epicondylitis-1.webp",
    photos: [
      { src: "/products/ortesi-tutori/para-epicondylitis-1.webp" },
      { src: "/products/ortesi-tutori/para-epicondylitis-2.webp" },
      { src: "/products/ortesi-tutori/para-epicondylitis-3.webp" },
      { src: "/products/ortesi-tutori/para-epicondylitis-4.webp" },
    ],
    features: [
      "Contribuisce alla riduzione del dolore e del gonfiore",
      "Struttura a maglia piatta tridimensionale",
      "Disponibile in quattro colori e sette taglie",
    ],
    description:
      "PARA EPICONDYLITIS stabilizza il gomito grazie alla lavorazione a maglia ondulata tridimensionale. L'elevata elasticità longitudinale consente al tutore di adattarsi anatomicamente al gomito. Il materiale traspirante, morbido ed elastico favorisce il comfort e una vestibilità stabile. L'imbottitura in silicone integrata scarica in modo mirato la zona degli epicondili e protegge le aree sensibili.",
    material: [["Poliammide", "63%"], ["Elastan", "37%"]],
    sizes: ["Taglia 1", "Taglia 2", "Taglia 3", "Taglia 4", "Taglia 5", "Taglia 6", "Taglia 7"],
    variants: ["Realizzabile anche su misura"],
    indications: [
      "Tendinosi da sovraccarico funzionale, compreso gomito del tennista e gomito del golfista",
      "Versamenti articolari e gonfiori associati ad artrosi e artrite",
      "Irritazioni post-operatorie e post-traumatiche",
    ],
    colors: [],
    colorsNote: "Disponibile in quattro colori — nomi esatti da confermare.",
    availableExecutions: [],
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "para-vertebral-light",
    id: "sch-para-vertebral-light",
    cover: "/products/ortesi-tutori/para-vertebral-light-3.webp",
    photos: [
      { src: "/products/ortesi-tutori/para-vertebral-light-3.webp" },
      { src: "/products/ortesi-tutori/para-vertebral-light-4.webp" },
      { src: "/products/ortesi-tutori/para-vertebral-light-2.webp" },
      { src: "/products/ortesi-tutori/para-vertebral-light-1.webp" },
    ],
    name: "PARA VERTEBRAL LIGHT",
    macro: "ortesi-tutori",
    featured: false,
    ralCertified: false,
    category: "Ortesi e tutori",
    title: "La fascia lombare leggera",
    features: [
      "Stabilizza la regione lombare",
      "Costruzione piatta e poco ingombrante",
      "Disponibile per circonferenze vita fino a oltre 140 cm",
    ],
    description:
      "PARA VERTEBRAL LIGHT è una fascia progettata per stabilizzare la regione lombare. Oltre all'effetto compressivo, gli elementi integrati contribuiscono a proteggere dai movimenti scorretti. La struttura sottile consente di indossarla discretamente sotto gli abiti e offre un supporto confortevole durante le attività quotidiane.",
    material: [["Poliammide", "65%"], ["Viscosa", "28%"], ["Elastan", "7%"]],
    sizes: ["da 52 cm", "fino a oltre 140 cm di circonferenza vita (7 taglie)"],
    variants: ["Disponibile anche nella versione più sostenuta con cinghie rinforzate"],
    indications: [
      "Condizioni dolorose della colonna lombare, comprese lombalgia e lombalgia ricorrente",
      "Spondilolisi senza spondilolistesi",
      "Alterazioni degenerative del disco intervertebrale e delle strutture ossee adiacenti, comprese spondiloartrosi e osteocondrosi",
    ],
    colors: [],
    colorsNote: "Disponibile in tre colori — nomi esatti da confermare.",
    availableExecutions: [],
    device: true,
    healthNote: HEALTH_NOTE,
  },

  // ---------------- ACCESSORI ----------------
  {
    slug: "bioclear",
    id: "sch-bioclear",
    name: "BIOCLEAR",
    macro: "accessori",
    featured: false,
    ralCertified: false,
    category: "Accessori per calze e indumenti compressivi",
    title: "Detergente speciale per calze e bendaggi compressivi",
    cover: "/products/accessori/bioclear-1.webp",
    photos: [
      { src: "/products/accessori/bioclear-1.webp" },
      { src: "/products/accessori/bioclear-2.webp" },
      { src: "/products/accessori/bioclear-3.webp" },
    ],
    features: [
      "Detergente concentrato biodegradabile",
      "Indicato per tessuti elastici particolarmente delicati",
      "Formula a pH neutro",
    ],
    description:
      "Detergente concentrato con tensioattivi di origine vegetale, specifico per la pulizia quotidiana di calze e bendaggi compressivi. Aiuta a rimuovere residui cutanei e sostanze grasse, preservando nel tempo le fibre e la funzione compressiva del prodotto.",
    ingredients: [
      "5–15% tensioattivi anionici",
      "meno del 5% tensioattivi non ionici",
      "profumi",
      "linalolo",
      "piritione di sodio",
      "benzisotiazolinone",
    ],
    ingredientsNote:
      "Ingredienti e avvertenze provvisori: da verificare sulla confezione italiana aggiornata o sulla scheda di sicurezza.",
    packages: ["Bottiglia singola", "Cartone da 24 bottiglie", "Cartone espositore da 9 bottiglie"],
    safetyBox: "Pericolo: provoca irritazione cutanea. Provoca gravi lesioni oculari.",
    colors: [],
    availableExecutions: [],
    device: false,
  },
  {
    slug: "arion-easy-slide",
    id: "sch-arion-easy-slide",
    name: "ARION EASY-SLIDE",
    macro: "accessori",
    featured: false,
    ralCertified: false,
    category: "Accessori per calze e indumenti compressivi",
    title: "L'ausilio per indossare calze compressive a punta aperta",
    cover: "/products/accessori/arion-easy-slide-1.webp",
    photos: [
      { src: "/products/accessori/arion-easy-slide-1.webp" },
    ],
    features: [
      "Facilita l'applicazione delle calze compressive a punta aperta",
      "Confezione compatta e utilizzo semplice",
      "Disponibile in cinque taglie, dalla XS alla XL",
    ],
    description:
      "ARION EASY-SLIDE facilita l'applicazione delle calze compressive a punta aperta. Il materiale a bassissimo attrito riduce lo sforzo necessario durante l'utilizzo. Quando non viene usato può essere ripiegato e trasportato facilmente, risultando pratico anche durante i viaggi o per il personale assistenziale.",
    material: [["Poliammide", "93%"], ["Poliuretano", "3%"], ["Silicone", "2%"], ["Poliestere", "2%"]],
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [],
    availableExecutions: [],
    device: false,
  },
];

export const getSchieblerProduct = (slug) => SCHIEBLER_PRODUCTS.find((p) => p.slug === slug);

// Prodotti raggruppati per macro-categoria, principali prima.
export const schieblerByCategory = () =>
  SCHIEBLER_CATEGORIES.map((cat) => ({
    ...cat,
    products: SCHIEBLER_PRODUCTS.filter((p) => p.macro === cat.id).sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0)),
  }));

// Lookup slug/link a partire dall'id di catalogo.
export const schieblerLinkById = (id) => {
  const p = SCHIEBLER_PRODUCTS.find((x) => x.id === id);
  return p ? `/prodotti/schiebler/${p.slug}` : "/prodotti/schiebler";
};
